import React from "react";
import DemoContent from "../../demo-content/DemoContent";
import DemoImg from "../../../images/divices.png";

import "./demo.css";

function MobileDemoSection() {
  return (
    <section className="flex flex-col">
        <img src={DemoImg} alt="mobile-demo-img" className="mobile-demo-img"/>
        <div className="mobile-demo-wrapper">
            <DemoContent isMobile />
        </div>
    </section>
  );
}

export default MobileDemoSection;
